<template>
<div class="chapter">
<div class="inner_page">
<h1 class="western" id="calibre_pb_8">CHAPTER ONE</h1>
<p class="western2"> <br class="calibre2"/></p>
<p class="western2"> <br class="calibre2"/></p>
<p class="western2"><a id="ch_1"></a>“I love you too, Daddy,
and I promise to vote in the presidential election on Tuesday
before I go to the seminar,” Christine Tiggs lied, disconnecting
the phone call from her father, John.</p>
<p class="western2">She had no intention of voting, she trusted
the government just like it was. She certainly didn’t mind the
weekly calls from her dad, and it wasn’t because he paid most of
her bills. She truly loved him and worried about him. He worked for
a mining employment group, Green Way, and was sent all over the
world. Christine worried because the crew he was foreman of was the
initial force in creating a working mine. What he did was dangerous
and more than once he had been trapped in a cave-in. Currently, he
was working in a remote portion of the Upper Peninsula of Michigan.
A quick internet search told her <i class="calibre4">all</i> of the U.P. was remote,
with nothing but trees and more trees. How could people live like
that? She shuddered.</p>
<p class="western2">She was also worried what he would say when
he found out her new job wasn’t quite what she’d led him to
believe. She’d coasted the last six months on unemployment,
enjoying the summer off and having a good time. Those checks had
run out though, and she had to find a job.</p>
<p class="western2">John had put Christine through school because
he felt that’s what parents did: prepare their children for the
real world with a good education. She had a degree in public
health, then took a semester of pre-med, finally deciding on a
career as a dental hygienist, and after graduation she had gotten a
nice job at a clinic in Fort Wayne, Indiana. After two years there,
they cut back the staff and she got laid-off. It was a good thing
she was single, since the only other job she could find after those
six months was in Greenwood, near Indianapolis, and she had to
move. What Christine didn’t tell her dad was that the new job,
though in a dental office, was only filling out insurance papers at
half her previous salary. She had hopes that it was just a stepping
stone for her. The good part of being in Greenwood was she was
closer to her grandmother in Louisville, Kentucky.</p>
<p class="western2">After staring at the phone another moment,
she frowned and went to her desk to pack her briefcase to be ready
for the morning. The seminar was actually a training session held
by one of the major dental insurance companies on how to fill out
the submission forms. It was sure to be a boring day, and at least
the dental office was picking up the tab. The training was near the
insurance company’s home office in Granite City, east of St. Louis.
It was a five hour drive, plus the following day-long training,
requiring Christine to spend two nights. She’d drive there on
Monday, have classes on Tuesday, drive home on Wednesday. Her heart
lightened thinking she could get some shopping done in the larger
city, on her dad’s credit card.</p>
<p class="western2"> <br class="calibre2"/></p>
<p class="western2">“Hey, Christine,” Lois Merkel said when
Christine answered her phone. “What time are you picking me up
tomorrow?”</p>
<p class="western2">“Oh, hi. How about around ten? It’s a long
drive and we can’t get there too early or the hotel won’t let us
register,” she replied. The dental office was sending two of them
for training and insisted they share a room to keep the expenses
down. Christine wasn’t sure about spending that much time with her
pudgy co-worker. Lois was okay, although her short, spiky, dyed
orange hair and all the tattoos gave Christine the creeps. She ran
her fingers through her recently cut blonde hair. She felt the
shorter cut made her look more sophisticated, although the short,
soft waves would take some getting used to.</p>
<p class="western2"> <br class="calibre2"/></p>
<p class="c4">***</p>
<p class="western2"> <br class="calibre2"/></p>
<p class="western2">Christine stopped her silvery blue PT Cruiser
when the hotel came into view. The new car had been a birthday
present from her dad.</p>
<p class="western2">“Something wrong?” Lois asked.</p>
<p class="western2">“No, the GPS says this is right place. It’s
just a surprise, that’s all.” Christine put the car back in gear
and headed for the parking lot. The large four-story building sat
in the center of a bulldozed block and lacked landscaping. The
surrounding area looked less than appealing with rundown apartment
buildings and shabby storefronts. Across the busy street was the
evidence of a few buildings being constructed, and beyond that were
more rundown buildings of questionable use. They were at the edge
of the city on a main highway and Christine couldn’t see a mall
anywhere.</p>
<p class="western2"> <br class="calibre2"/></p>
<p class="c4">***</p>
<p class="western2"> <br class="calibre2"/></p>
<p class="western2">“This looks like a nice place,” Lois
commented, turning a circle in the lobby of the hotel. The vaulted
ceilings bespoke of opulence with the high recessed lighting that
gave a soft glow to the peaches and cream décor and fake greenery.
Her heavy overnight bag dragged on her shoulder and off-balanced
her as she turned back to the desk.</p>
<p class="western2">Christine took a deep, steadying breath and
smiled tightly at the reception clerk. The five hour drive had been
nerve wracking: Lois never stopped talking. She signed the register
and took the two key cards, handing one to her co-worker.</p>
<p class="western2">“Our room is on the third floor and the
conference room is on the second,” Christine announced as they made
their way to the elevator, glancing at the brochure and floor plan
she was given. “Pool and exercise room is on the main level and so
is the bar/restaurant.”</p>
<p class="western2">“Great! I sure could use a beer!” Lois said
gleefully.</p>
<p class="western2">“Yeah, I could use a drink myself,” Christine
muttered.</p>
<p class="western2"> <br class="calibre2"/></p>
<p class="c4">***</p>
<p class="western2"> <br class="calibre2"/></p>
<p class="western2">The frozen strawberry margarita was just what
Christine needed to deal with Lois’ non-stop chatter. After her
second beer though, Lois quieted down a bit.</p>
<p class="western2">“Why don’t we go shopping?” Christine
suggested. “The desk clerk said there’s a nice shopping mall only
six blocks away. We can take their shuttle or walk.”</p>
<p class="western2">“Walk? I vote for the shuttle.” Lois grinned.
“I don’t want to lose my buzz by getting some exercise.”</p>
<p class="western2">Christine nodded in agreement once she
remembered what the surrounding neighborhood looked like. Walking
six blocks was sure to take them through some questionable, maybe
even dangerous, areas.</p>
<p class="western2"> <br class="calibre2"/></p>
<p class="c4">***</p>
<p class="western2"> <br class="calibre2"/></p>
<p class="western2">The mall ended up being a small two-story
structure with only a few dozen stores, explaining why Christine
couldn’t see it from the hotel. At least the stores were top-notch
and brand names.</p>
<p class="western2">“Aren’t these leggings adorable?” Lois
exclaimed, picking up the snug, hot pink, sequined pants.</p>
<p class="western2">“And they’re the latest thing going,”
Christine said. She had to admit they really were cute and she was
all for staying in style. “I think I’ll get black, the green, and
those deep blue ones. Now I need some matching tops.” She set her
selections on the sales counter to go look at the long sweaters,
and didn’t notice Lois slide the pink ones under the pile.</p>
<p class="western2">After adding a couple of tops to layer over
some new camisoles, and two sweaters, Christine handed over her
dad’s credit card.</p>
<p class="western2">Christine was now feeling the high she always
got when she went on a mindless shopping spree at her father’s
expense. He never said a word to her, he just paid the bill.</p>
<p class="western2"> <br class="calibre2"/></p>
<p class="c4">***</p>
<p class="western2"> <br class="calibre2"/></p>
<p class="western2">“Those new boots are going to look great with
the leggings,” Lois said, sipping another beer in the food
court.</p>
<p class="western2">“Probably a bit of a splurge on my part,”
Christine said, thinking of the impractical knee high, high heeled
boots in the brown soft suede leather. “I really do need those
walking shoes though. We’re on our feet all day at the office, and
my poor tootsies just ache by five o’clock.” Christine now had
several packages piled on the extra chairs at their table. A little
bit of guilt crept into her at the two hundred dollars she’d spent
at the shoe store and justified it by knowing the walking shoes
were for work. Another sip of her icy drink tamped the remaining
guilt down.</p>
<p class="western2">“I’m getting hungry,” Lois said, “how about
you?” She looked around at the different vendors available.</p>
<p class="western2">“I could eat, but let’s go back and try the
hotel restaurant. That way it goes on the clinic’s tab,” Christine
said, knowing somehow Lois would get her to pay for both dinners if
they stayed there.</p>
<p class="western2"> <br class="calibre2"/></p>
<p class="c4">***</p>
<p class="western2"> <br class="calibre2"/></p>
<p class="western2">“Typical bar food,” Lois grumbled. “We should
have had the sushi at the food court.”</p>
<p class="western2">“I doubt that would have been very good, and
I wouldn’t have trusted it,” Christine responded. “Besides, what’s
wrong with that chicken parmesan? It looks really good.” Lois
shrugged and gulped down some of the red wine they had ordered.</p>
<p class="western2">“Your shrimp teriyaki looks better. Can I
have a bite?” Lois asked, spearing the last piece of chicken on her
plate and plopping it in her mouth.</p>
<p class="western2">“No, we will still have dinner here tomorrow
night so you can order it then,” Christine said and feeling a bit
irritated, she poured the rest of the bottle of wine into her own
glass. Lois was definitely getting on her nerves.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// tmp_81917b76c0dc0690a3d5075948c70f3d_BuZtIk.ch.fixed.fc.tidied.stylehacked.xfixed_split_008.vue?6c9c00c6